import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalLinkOutlined = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 36 36",
	fill: "currentColor",
	focusable: "false",
	"aria-hidden": "true",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.66002 33.4455H32.703C33.4196 33.4455 34.0005 32.8646 34.0005 32.148V16.3647C34.0005 16.1238 33.8052 15.9286 33.5643 15.9286H31.8743C31.6335 15.9286 31.4382 16.1238 31.4382 16.3647L31.4382 30.8832L5.92479 30.8832L5.92479 5.09725L19.2481 5.09725C19.489 5.09725 19.6842 4.90199 19.6842 4.66112L19.6842 2.97113C19.6842 2.73027 19.489 2.535 19.2481 2.535H4.66003C3.94345 2.535 3.36255 3.1159 3.36255 3.83248L3.36255 32.148C3.36255 32.8646 3.94342 33.4455 4.66002 33.4455ZM33.3654 2.96183L26.1169 3.35944C25.8457 3.37378 25.7148 3.69278 25.8928 3.89453L27.9121 6.18298L15.1652 17.7177C15.0327 17.8346 15.02 18.0386 15.1369 18.1711L16.6247 19.8573C16.7416 19.9898 16.9457 20.0026 17.0781 19.8857L29.825 8.35099L31.8442 10.6394C32.0222 10.8412 32.358 10.7484 32.403 10.4837L33.7001 3.34123C33.709 3.29329 33.7069 3.24395 33.6939 3.19695C33.6809 3.14996 33.6574 3.10654 33.6252 3.06998C33.5929 3.03341 33.5528 3.00467 33.5077 2.98594C33.4627 2.9672 33.414 2.95895 33.3654 2.96183Z",
		fillOpacity: .85
	})]
});
const ForwardRef = forwardRef(SvgExternalLinkOutlined);
export { ForwardRef as ReactComponent };
